/*
 if we want to intercept the request to api (to add auth or sth)
 we need to add "fake" prefix %CONTENT-API%/
 for details check 'mixins/componentConfiguration.js'
*/

module.exports = {
  SEARCH: '%CONTENT-API%/public/sitesearch/{indexSuffix}?query={query}&meta=breadcrumbs&filters={filters}&offset={offset}'
}
